import { createClient } from '@supabase/supabase-js';
import { createPgrst303RetryFetch } from '@packages/shared-utils';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
/**
 * Base Supabase service
 * Provides common database operations
 */
export class SupabaseService {
    static initialize(supabaseUrl, supabaseAnonKey, options) {
        var _a, _b;
        if (!SupabaseService.instance) {
            const userFetch = (_b = (_a = options === null || options === void 0 ? void 0 : options.global) === null || _a === void 0 ? void 0 : _a.fetch) !== null && _b !== void 0 ? _b : globalThis.fetch.bind(globalThis);
            const fetchWithRetry = createPgrst303RetryFetch(userFetch);
            const client = createClient(supabaseUrl, supabaseAnonKey, Object.assign(Object.assign({}, options), { global: Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.global), { fetch: fetchWithRetry }) }));
            SupabaseService.instance = new SupabaseService(client);
        }
    }
    static getInstance() {
        if (!SupabaseService.instance) {
            throw new Error('Supabase service not initialized. Please call initialize() or initializeWithClient() first.');
        }
        return SupabaseService.instance;
    }
    static getClient() {
        return SupabaseService.getInstance().client;
    }
    static destroy() {
        if (SupabaseService.instance) {
            // Clean up any active sessions
            SupabaseService.instance.client.auth.signOut({ scope: 'local' });
            SupabaseService.instance = undefined;
        }
    }
    constructor(client) {
        this.client = client;
    }
    /**
     * Get the current authenticated user
     */
    getCurrentUser() {
        return this.client.auth.getUser().then(({ data }) => { var _a; return (_a = data.user) !== null && _a !== void 0 ? _a : null; });
    }
    /**
     * Upload file to storage
     */
    uploadFile(bucket, path, file, options) {
        var _a;
        return from(this.client.storage.from(bucket).upload(path, file, { upsert: (_a = options === null || options === void 0 ? void 0 : options.upsert) !== null && _a !== void 0 ? _a : false })).pipe(map((response) => {
            var _a, _b, _c, _d;
            if (response.error)
                throw response.error;
            const { data: urlData } = this.client.storage
                .from(bucket)
                .getPublicUrl((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.path) !== null && _b !== void 0 ? _b : path);
            return {
                path: (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.path) !== null && _d !== void 0 ? _d : path,
                url: urlData.publicUrl,
            };
        }));
    }
    /**
     * Delete file from storage
     */
    deleteFile(bucket, path) {
        return from(this.client.storage.from(bucket).remove([path]));
    }
    /**
     * Get public URL for a file
     */
    getPublicUrl(bucket, path) {
        const { data } = this.client.storage.from(bucket).getPublicUrl(path);
        return data.publicUrl;
    }
}
